import React, { useEffect, useState } from 'react'
import './_account-settings.scss'

import { CurrentUser } from '../typedefs'
import { onButtonTriggerKey, isButtonTriggerKey } from '../../utils'

export type AccountSettinsProps = {
  handleLogOut: () => void
  onFirstShow: (() => void) | null
  currentUser: CurrentUser
  handleClosePopupClick: () => void
}

export default function AccountSettings(props: AccountSettinsProps) {
  const { handleLogOut, onFirstShow, currentUser, handleClosePopupClick } =
    props
  const [showModal, setShowModal] = useState(false)
  const [signedInAs, setSignedInAs] = useState('')
  const [isFirstShow, setIsFirstShow] = useState(true)

  const handleOutsideClick = () => {
    setShowModal(false)
  }

  const handleInsideClick = (e: any) => {
    e.stopPropagation()
    if (!e.target.closest('.frw-account-settings-container')) {
      setShowModal(!showModal)
    }
  }

  const handleInsideKeystroke = (e: KeyboardEvent) => {
    // let anchors handle their keystrokes natively
    if (e.target === e.currentTarget && isButtonTriggerKey(e)) {
      e.preventDefault()
      handleInsideClick(e)
    }
  }

  useEffect(() => {
    document.addEventListener('click', handleOutsideClick)

    return () => {
      document.removeEventListener('click', handleOutsideClick)
    }
  }, [])

  useEffect(() => {
    const firstName = currentUser.firstName || ''
    const lastName = currentUser.lastName || ''
    const fullName = `${firstName} ${lastName}`.trim()
    if (fullName) {
      setSignedInAs(`as ${fullName}`)
    } else {
      setSignedInAs('')
    }
  }, [currentUser])

  useEffect(() => {
    if (showModal) {
      handleClosePopupClick()
    }
    if (showModal && isFirstShow) {
      setIsFirstShow(false)
      if (onFirstShow) {
        onFirstShow()
      }
    }
  }, [showModal])

  return (
    <span role="navigation">
      <div
        className="frw-account-settings"
        onClick={handleInsideClick}
        onKeyDown={handleInsideKeystroke}
        data-testid="user-icon"
        tabIndex={0}
        role="button"
      >
        <div>
          <div className="">
            <div className="frw-account">
              <a className="frw-account__sign-in">
                <i className="far fa-user-circle" /> {`My Account `}{' '}
                <i className="fas fa-caret-down" />
              </a>
            </div>
            {showModal && (
              <div
                className="frw-column-6 frw-account-settings-container"
                id="account-settings-container"
                data-testid="modal"
              >
                <div className="frw-flex-item">
                  <div className="frw-account__navigation">
                    <h5 className="frw-user">{`Signed in ${signedInAs}`}</h5>
                    <ul>
                      <li>
                        <a
                          aria-label="basic info"
                          href="/user-settings/basic-info"
                        >
                          Basic Info
                        </a>
                      </li>
                      <li>
                        <a
                          aria-label="alert settings"
                          href="/user-settings/alert-settings"
                        >
                          Alert Settings
                        </a>
                      </li>
                      <li>
                        <a
                          aria-label="change password"
                          href="/user-settings/change-password"
                        >
                          Change Password
                        </a>
                      </li>
                    </ul>
                    <div className="frw-button__wrapper frw-button__wrapper--2">
                      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                      <a
                        aria-label="sign out"
                        tabIndex={0}
                        className="frw-button frw-button--4"
                        onClick={handleLogOut}
                        onKeyDown={onButtonTriggerKey(handleLogOut)}
                        data-testid="logout-trigger"
                        role="button"
                      >
                        Sign Out
                      </a>
                    </div>
                  </div>
                </div>
                <div />
              </div>
            )}
          </div>
        </div>
      </div>
    </span>
  )
}
